// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiWaveCurationRequest {
    'name': string;
    'group_id': string;
    'priority_order'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "group_id",
            "baseName": "group_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "priority_order",
            "baseName": "priority_order",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveCurationRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
